import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  googleMaps: {
    id: 'jutro-components.widgets.MapArea.GoogleMaps',
    defaultMessage: 'Google Maps'
  }
});